import calendar_en from './locales/en/calendar.json';
import calendar_sk from './locales/sk/calendar.json';
import common_en from './locales/en/common.json';
import common_sk from './locales/sk/common.json';
import navigation_en from './locales/en/navigation.json';
import navigation_sk from './locales/sk/navigation.json';
import chat_en from './locales/en/chat.json';
import chat_sk from './locales/sk/chat.json';
import auth_en from './locales/en/auth.json';
import auth_sk from './locales/sk/auth.json';
import workout_en from './locales/en/workout.json';
import workout_sk from './locales/sk/workout.json';
import meal_en from './locales/en/meal.json';
import meal_sk from './locales/sk/meal.json';
import user_en from './locales/en/user.json';
import user_sk from './locales/sk/user.json';
import subscription_en from './locales/en/subscription.json';
import subscription_sk from './locales/sk/subscription.json';

const resources = {
  en: {
    calendar: calendar_en,
    common: common_en,
    navigation: navigation_en,
    chat: chat_en,
    auth: auth_en,
    workout: workout_en,
    meal: meal_en,
    user: user_en,
    subscription: subscription_en,
  },
  sk: {
    calendar: calendar_sk,
    common: common_sk,
    navigation: navigation_sk,
    chat: chat_sk,
    auth: auth_sk,
    workout: workout_sk,
    meal: meal_sk,
    user: user_sk,
    subscription: subscription_sk,
  },
};

export default resources;
